import React from 'react';
import AnswerOption from 'routes/surface/components/node-modal-form/components/questionnaire-node-modal/components/questionnaire-node-form/components/answer-option';
import withForm from 'components/form/hoc/with-form';
import { Container } from './style';
import { color } from 'styles/settings';
import { WithMargin } from 'components/layout';

enum ANSWER_TYPE {
  YES = 'yes',
  NO = 'no',
  OPEN = 'open',
}

interface AnswerTypeOptionsProps {
  onChange: Function;
  name: string;
  value?: ANSWER_TYPE;
  disabled?: boolean;
}

export function AnswerTypeOptions(props: AnswerTypeOptionsProps) {
  const [answer, setAnswer] = React.useState<ANSWER_TYPE | undefined>(
    props.value,
  );

  function onClick(answer) {
    if (props.disabled) {
      return;
    }

    setAnswer(answer);
    props.onChange(answer);
  }

  return (
    <Container>
      <AnswerOption
        value={ANSWER_TYPE.YES}
        color={color.brand.green}
        selected={answer === ANSWER_TYPE.YES}
        disabled={props.disabled}
        selectedColor={color.neutral.white}
        onClick={onClick}
      />

      <WithMargin left="30px" right="30px">
        <AnswerOption
          value={ANSWER_TYPE.NO}
          color={color.ui.danger}
          selected={answer === ANSWER_TYPE.NO}
          disabled={props.disabled}
          selectedColor={color.neutral.white}
          onClick={onClick}
        />
      </WithMargin>

      <AnswerOption
        value={ANSWER_TYPE.OPEN}
        color={color.neutral.plainBlack}
        selected={answer === ANSWER_TYPE.OPEN}
        disabled={props.disabled}
        selectedColor={color.neutral.white}
        onClick={onClick}
      />
    </Container>
  );
}

export default withForm(AnswerTypeOptions);
